import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/DrawCRUDConfig.json";
import PageHeader from "../../components/PageHeader";
import CustomCard from "../../utils/Card/CustomCard";
import { Box } from "@mui/material";
const DrawsPage = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          flexGrow: 1,
          marginTop: 0,
          marginLeft: 15,
          marginRight: 15,
          marginBottom: 15,
        }}
      >
        <PageHeader pageTitle="Manage Your Draw" />

        <CrudManager
          data={schema}
          actionBtnName="Add New Draw"
          createFormTitle="Add Draw"
          updateFormTitle="Update Draw"
        />
      </Box>
    </Box>
  );
};

export default DrawsPage;
